import React, { useEffect } from "react";
import "./AboutUs.css";
import PageHeader from "./PageHeader";

const AboutUs = () => {
  useEffect(() => {
    const animateOnScroll = () => {
      const elements = document.querySelectorAll(".animate");
      const triggerPoint = window.innerHeight * 0.85;

      elements.forEach((el) => {
        const position = el.getBoundingClientRect().top;
        if (position < triggerPoint) {
          el.classList.add("visible");
        }
      });

      // Special stagger for doctor section
      const doctorSection = document.querySelector(".doctor-couple-section");
      if (doctorSection) {
        const sectionPos = doctorSection.getBoundingClientRect().top;
        if (sectionPos < triggerPoint) {
          const children = doctorSection.querySelectorAll(".animate");
          children.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add("visible");
            }, index * 450);
          });
        }
      }
    };

    window.addEventListener("scroll", animateOnScroll);
    animateOnScroll(); // Trigger on mount
    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  // SEO & Structured Data
  useEffect(() => {
    // Meta title
    document.title = "About Us | Dr. Chavan Multispeciality Hospital, Indapur";

    // Meta description
    const metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content =
      "Learn about Dr. Chavan Multispeciality Hospital in Indapur, our vision, mission, motto, values, and the expert doctor couple providing compassionate, advanced healthcare.";
    document.head.appendChild(metaDescription);

    // Keywords
    const metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      "About Dr. Chavan Hospital, Indapur hospital, expert doctors, vision mission motto, healthcare values";
    document.head.appendChild(metaKeywords);

    // Canonical
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://drchavanhospital.in/about-us";
    document.head.appendChild(canonical);

    // JSON-LD Structured Data for Organization
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Hospital",
      "name": "Dr. Chavan Multispeciality Hospital",
      "url": "https://drchavanhospital.in/",
      "logo": "https://drchavanhospital.in/images/logo.webp",
      "image": "https://drchavanhospital.in/images/pageheader.jpg",
      "description": "Dr. Chavan Multispeciality Hospital in Indapur provides advanced multispeciality healthcare led by a compassionate doctor couple.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Indapur",
        "addressLocality": "Indapur",
        "addressRegion": "Maharashtra",
        "postalCode": "413106",
        "addressCountry": "IN"
      },
      "founders": [
        {
          "@type": "Person",
          "name": "Dr. [Husband Name]",
          "jobTitle": "Doctor",
        },
        {
          "@type": "Person",
          "name": "Dr. [Wife Name]",
          "jobTitle": "Doctor",
        }
      ],
      "sameAs": [
        "https://www.facebook.com/yourhospital",
        "https://www.instagram.com/yourhospital",
        "https://www.linkedin.com/company/yourhospital"
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(metaDescription);
      document.head.removeChild(metaKeywords);
      document.head.removeChild(canonical);
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="about-us-container">
      <PageHeader
        title="Who We Are"
        breadcrumbs={["Home", "About Us"]}
        background="../images/pg.webp"
      />

      {/* VISION - MISSION - MOTTO */}
      <section className="vm-section">
        <div className="vm-cards">
          <div className="vm-card animate slide-left">
            <h2 className="vision-title">Vision</h2>
            <p>
              Quality, Empathetic & Holistic care that is affordable and accessible.
            </p>
          </div>

          <div className="vm-card animate slide-left">
            <h2 className="mission-title">Mission</h2>
            <p>To modernize healthcare journey through integration of technology.</p>
          </div>

          <div className="vm-card animate slide-left">
            <h2 className="motto-title">Motto</h2>
            <p>"Quality Care, Affordable for All!"</p>
          </div>
        </div>

        <div className="value-section animate slide-right">
          <div className="value-header">
            <small>OUR VALUE</small>
            <h1>A Vision for Compassionate & Advanced Healthcare</h1>
            <h3>Healing With Expertise, Care, and Commitment</h3>
          </div>
          <div className="value-content">
            <p>
              Dr. Chavan Multispeciality Hospital is a trusted centre of excellence
              dedicated to delivering comprehensive, patient-focused medical care.
              With modern technology, specialized departments, and a team of experienced doctors,
              we ensure accurate diagnosis, effective treatment, and faster recovery.
            </p>
          </div>
        </div>
      </section>

      {/* DOCTOR COUPLE SECTION */}
      <section className="doctor-couple-section">
        <div className="doctor-couple-wrapper">
          <div className="doctor-couple-image animate slide-left">
            <img src="./images/both.webp" alt="Doctor Couple" />
          </div>

          <div className="doctor-couple-text animate slide-right">
            <small>OUR DOCTORS</small>
            <h2>Meet the Experts Behind Dr. Chavan Multispeciality Hospital</h2>

            <p>
              The hospital is led by a compassionate and highly experienced doctor couple 
              who are dedicated to providing exceptional healthcare to the community.
            </p>

            <p>
              Their shared vision is to make high-quality healthcare accessible and affordable,
              while maintaining the highest standards of treatment, technology, and personalized care.
            </p>

            <ul className="doctor-couple-highlights animate slide-up">
              <li>✔ Strong expertise across multiple specialties</li>
              <li>✔ A unified mission for modern, compassionate healthcare</li>
              <li>✔ Ethical treatments & patient-centric approach</li>
              <li>✔ Leaders in advanced medical technology</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
